// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Store
// -------------------------------------------------------------------------------
import { useGetMixByIdQuery } from '../../store/queries/rows';

// -------------------------------------------------------------------------------
// Components
// -------------------------------------------------------------------------------
import MusicPlayer from '../music-player/MusicPlayer';

// -------------------------------------------------------------------------------
// Styles and Utils
// -------------------------------------------------------------------------------
import { StyledMusicPlayerRow } from './style';

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
export function MusicPlayerRow({ track, firstLoad }) {
  const { data } = useGetMixByIdQuery({ id: track?.id }, { skip: !track?.id });

  return (
    <StyledMusicPlayerRow>
      {data && <MusicPlayer track={track} data={data} firstLoad={firstLoad} />}
    </StyledMusicPlayerRow>
  );
}

export default MusicPlayerRow;
